import moment, { MomentInput } from 'moment-timezone';
import { PersonSalaryLimitData } from '@tymbe/schema/person-salary-limit.interface';
import { SalaryLimitType } from '@tymbe/schema/enums';

export const getSalaryLimitMonth = (date?: MomentInput): string =>
  moment(date).tz('Europe/Prague').startOf('month').toISOString();

export const shouldTaxesBeAvoided = (salaryLimit?: PersonSalaryLimitData): boolean =>
  Boolean(salaryLimit && salaryLimit.limit === SalaryLimitType.AVOID_TAXES);
